/**
 * Simkl poster URLs.
 *
 * The API returns a bare path like "86/86901726e30f1f813"; the CDN needs a size
 * suffix. Measured on 2026-09-17 — a path with no suffix 404s:
 *
 *   _c   170x250   ~15 KB   list rows
 *   _ca  190x279   ~18 KB
 *   _m   340x500   ~51 KB   poster grids and detail headers
 *   _w   600x338            widescreen art, unused
 */
const SIZES = {
  row: "_c",
  grid: "_m",
  /* The largest the CDN serves. Only the full-screen viewer asks for it. */
  full: "_m",
} as const;

export type PosterSize = keyof typeof SIZES;

export function posterUrl(path: string | null, size: PosterSize): string | null {
  if (path === null || path.length === 0) return null;
  return `https://simkl.in/posters/${path}${SIZES[size]}.jpg`;
}
